import { Icon } from './icon';

export const IconPlus = () => (
  <Icon>
    <path d="M12 3V21" />
    <path d="M3 12L21 12" />
  </Icon>
);
